<script setup lang="ts">
import { ref } from 'vue';
import { getApiRoot } from '~/utilities/api';
import { BASE_TITLE } from '~/utilities/constants';

useHead({
  title: `Fresh Mints ${BASE_TITLE}`,
  meta: [{ property: 'og:title', content: `Fresh Mints ${BASE_TITLE}` }],
});

const bottom = ref();
const { items: mints, pending } = useInfiniteScroll(bottom, () => `${getApiRoot()}/collections/minting`);
</script>

<template>
  <div>
    <div>
      <Container>
        <div class="py-8 sm:py-16">
          <div class="text-center">
            <p
              class="text-4xl font-extrabold text-neutral-900 dark:text-neutral-50 sm:text-5xl sm:tracking-tight lg:text-5xl"
            >
              Fresh Mints
            </p>
            <p class="mt-2 text-center text-neutral-700 dark:text-neutral-300">
              NFTs are minted dynamically on purchase.<br />
              Create your own edition using our
              <NuxtLink to="/mint" class="font-bold text-emerald-600 dark:text-white">Web Minting</NuxtLink>
              .
            </p>
          </div>
        </div>
        <div class="w-full">
          <HomeMints :mints="mints" :pending="pending" />
          <div ref="bottom"></div>
        </div>
      </Container>
    </div>
  </div>
</template>
